import { BaseOptions } from "@devowl-wp/utils";
const getStaticOptions = ()=>window[BaseOptions.getPureSlug(process.env.slug, true)].others;
export { getStaticOptions };
